import { ModuleType } from "../types/interfaces";

export class ModuleTypeRegistry {
  private static instance: ModuleTypeRegistry;
  private moduleTypes: Map<string, ModuleType> = new Map();
  private idToClassName: Map<number, string> = new Map();

  static getInstance(): ModuleTypeRegistry {
    if (!ModuleTypeRegistry.instance) {
      ModuleTypeRegistry.instance = new ModuleTypeRegistry();
    }
    return ModuleTypeRegistry.instance;
  }

  // Initialize from /module-types endpoint
  initialize(moduleTypes: ModuleType[]): void {
    this.moduleTypes.clear();
    this.idToClassName.clear();
    
    moduleTypes.forEach(moduleType => {
      this.moduleTypes.set(moduleType.class_name, moduleType);
      this.idToClassName.set(moduleType.id, moduleType.class_name);
    });
  }

  // Get current ID by class name
  getIdByClassName(className: string): number | undefined {
    return this.moduleTypes.get(className)?.id;
  }

  // Get class name by ID
  getClassNameById(id: number): string | undefined {
    return this.idToClassName.get(id);
  }

  // Get all module types
  getAllModuleTypes(): ModuleType[] {
    return Array.from(this.moduleTypes.values());
  }

  // Check if module is LUC by class name
  isLucModule(className: string): boolean {
    return this.moduleTypes.get(className)?.is_luc ?? false;
  }

  // Check if module is LUC by ID
  isLucModuleById(id: number): boolean {
    const className = this.getClassNameById(id);
    return className ? this.isLucModule(className) : false;
  }

  // Get module info by class name
  getModuleInfoByClassName(className: string): ModuleType | undefined {
    return this.moduleTypes.get(className);
  }

  // Get module info by ID
  getModuleInfoById(id: number): ModuleType | undefined {
    const className = this.getClassNameById(id);
    return className ? this.getModuleInfoByClassName(className) : undefined;
  }
}